<template>
  <div class="tab-view">
    <TabViewMenu
      v-model:active-key="activeTabKey"
      :tabs="tabs"
      @update:active-key="emit('update:active-key', $event as KEY)"
    />

    <div
      class="tab-view__content"
      :class="contentClasses"
    >
      <slot :active-key="activeTabKey" />
    </div>
  </div>
</template>

<script setup lang="ts" generic="KEY extends string">
import {
  shallowRef,
} from 'vue';

import {
  TabViewItem,
} from './tab-view';
import TabViewMenu from './tab-view-menu.vue';

const props = defineProps<{
  tabs: TabViewItem<KEY>[],
  activeKey?: KEY,
  contentClasses?: string[],
}>();

const emit = defineEmits<{
  (e: 'update:active-key', value: KEY | undefined): void,
}>();

defineSlots<{
  default(props: {
    activeKey: KEY | undefined,
  }): any,
}>();

const activeTabKey = shallowRef<KEY | undefined>(props.activeKey ?? props.tabs[0]?.key);
</script>

<style scoped lang="scss">
.tab-view {
  display: flex;
  flex-direction: column;

  &__menu {
    .icon {
      margin-right: 0.5rem;
    }

    svg {
      width: 1rem;
      height: 1rem;
    }
  }

  &__content {
    margin-top: var(--gap-section);
    flex: 1;
  }

  &__panel {
    height: 100%;
  }
}
</style>
